import React from "react";
import { motion } from "framer-motion";
import "./LoadingScreen.scss";

const LoadingScreen: React.FC = () => {
  return (
    <div className="loading-screen">
      <motion.div
        className="loading-content"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="loading-logo mb-0">
          <img
            src="/loading-loader.gif"
            alt="loader"
            width="108"
            height="113"
          />
        </div>

        <motion.p
          className="loading-text text-2xl font-semibold text-[#17150b] mb-[30px]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          Preparing your AI-powered experience...
        </motion.p>
        {/* <motion.p
          className="text-sm font-semibold text-[#7d7b78] mb-[30px]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          Setting up your AI-Powered landing page creation expierence
        </motion.p> */}
        <div className="loading-indicator">
          <motion.div
            className="loading-bar"
            initial={{ width: 0 }}
            animate={{ width: "100%" }}
            transition={{
              duration: 3,
              ease: "easeInOut",
              repeat: Infinity,
            }}
          />
        </div>
      </motion.div>

      {/* Background effects */}
      {/* <div className="loading-bg-effects">
        <div className="effect-1"></div>
        <div className="effect-2"></div>
        <div className="effect-3"></div>
      </div> */}
    </div>
  );
};

export default LoadingScreen;
